import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
const t = (k, p) => app.translator.trans('ernestdefoe-acc.forum.' + k, p);
/**
 * The first-layer cookie notice. Presentational: the mounted root passes the
 * config + the accept / reject / customize callbacks.
 */
export default class CookieBanner extends Component {
  view() {
    const cfg = this.attrs.config;
    const onAccept = this.attrs.onAccept;
    const onReject = this.attrs.onReject;
    const onCustomize = this.attrs.onCustomize;
    return m('.CookieBanner.CookieBanner--' + cfg.position, {
      role: 'dialog',
      'aria-label': t('banner.aria')
    }, [m('.CookieBanner-inner', [m('.CookieBanner-body', [m('h2.CookieBanner-title', cfg.title || t('banner.title')), m('p.CookieBanner-message', cfg.message || t('banner.message')), m('.CookieBanner-links', [cfg.privacyUrl ? m('a.CookieBanner-link', {
      href: cfg.privacyUrl,
      target: '_blank',
      rel: 'noopener'
    }, cfg.privacyLabel || t('banner.privacy')) : null, m('button.CookieBanner-link', {
      type: 'button',
      onclick: onCustomize
    }, t('banner.more'))])]), m('.CookieBanner-actions', [cfg.showRejectAll ? m('button.Button.CookieBanner-reject', {
      type: 'button',
      onclick: onReject
    }, t('banner.reject')) : null, m('button.Button.CookieBanner-customize', {
      type: 'button',
      onclick: onCustomize
    }, t('banner.customize')), m('button.Button.Button--primary.CookieBanner-accept', {
      type: 'button',
      onclick: onAccept
    }, t('banner.accept'))])])]);
  }
}
flarum.reg.add('ernestdefoe-advanced-cookie-consent', 'forum/components/CookieBanner', CookieBanner);